const share = {
  profile: 'Perfil',
  share: 'Compartir',
  scan: 'Escanear',
  publish: 'Publicar',
}


export default share
